import {
  IconFile,
  IconFileTypeBmp,
  IconFileTypeCsv,
  IconFileTypeDoc,
  IconFileTypeDocx,
  IconFileTypeJpg,
  IconFileTypePdf,
  IconFileTypePng,
  IconFileTypePpt,
  IconFileTypeSvg,
  IconFileTypeXls,
  IconFileTypeXml,
  IconPhoto,
  type TablerIcon
} from "@tabler/icons-react";

const FILE_TYPES_TO_TABLER_ICONS: Record<string, TablerIcon> = {
  xls: IconFileTypeXls,
  xlsx: IconFileTypeXls,
  csv: IconFileTypeCsv,
  doc: IconFileTypeDoc,
  docx: IconFileTypeDocx,
  pdf: IconFileTypePdf,
  ppt: IconFileTypePpt,
  pptx: IconFileTypePpt,
  pptm: IconFileTypePpt,
  jpg: IconFileTypeJpg,
  jpeg: IconFileTypeJpg,
  gif: IconPhoto,
  tiff: IconPhoto,
  png: IconFileTypePng,
  bmp: IconFileTypeBmp,
  svg: IconFileTypeSvg,
  xml: IconFileTypeXml
} as const;

/** Matches a file extension to an appropriate Tabler icon. */
export function getTablerIconByFileExtension(fileExtension: string) {
  const lowerCaseFileExtension = fileExtension.toLowerCase();
  return FILE_TYPES_TO_TABLER_ICONS[lowerCaseFileExtension] ?? IconFile;
}
